module.exports = __webpack_public_path__ + "img/f2.35edc548.png";